module.exports = __webpack_public_path__ + "static/media/universidad-villanueva.320c483b.jpg";